import React from 'react';
import classNames from 'classnames';
import styles from './FormBlock.module.scss';
import { Spinner } from '../Base/Spinner';
export const Cypress_DATA = {
  formBlock: 'layout-form-block',
  title: 'layout-form-block-title',
  deleteIcon: 'layout-form-block-delete-icon',
};

type Props = {
  children: React.ReactNode;
  title?: string;
  dataCy?: string;
  onDelete?: () => void;
  DeleteIcon?: React.ElementType;
  isLoading?: boolean;
  loadingText?: string;
  className?: string;
};

const FormBlock = ({
  title,
  children,
  dataCy,
  onDelete,
  DeleteIcon,
  isLoading = false,
  loadingText,
  className,
}: Props) => {
  return (
    <section
      className={classNames(styles.wrapper, className)}
      data-cy={dataCy ?? Cypress_DATA.formBlock}
    >
      {title && (
        <div className={styles.header}>
          <h1 className={styles.title} data-cy={Cypress_DATA.title}>
            {title}
          </h1>
          {onDelete && DeleteIcon && (
            <DeleteIcon
              className={styles.deleteIcon}
              onClick={onDelete}
              data-cy={Cypress_DATA.deleteIcon}
              fontSize="medium"
            />
          )}
        </div>
      )}
      <div className={styles.content}>
        {children}
        {isLoading && (
          <div className={styles.loadingOverlay}>
            <Spinner centered size={128} text={loadingText} />
          </div>
        )}
      </div>
    </section>
  );
};

export default FormBlock;
